import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import BackButton from '../components/BackButton';

export default function InvoicePaymentPage() {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');

  const [invoice, setInvoice] = useState(null);
  const [loadingInvoice, setLoadingInvoice] = useState(true);
  const [saving, setSaving] = useState(false);

  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  const [payment, setPayment] = useState({
    PaidAmount: '',
    PaymentMode: 'Cash',
    Remarks: '',
  });

  useEffect(() => {
    api.get(`/invoices/${invoiceId}?userId=${userId}`)
      .then(res => setInvoice(res.data.invoice))
      .catch(err => console.error('Failed to fetch invoice:', err))
      .finally(() => setLoadingInvoice(false));
  }, [invoiceId, userId]);

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPayment(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!payment.PaidAmount || parseFloat(payment.PaidAmount) <= 0) {
      setToast({ show: true, message: 'Enter a valid payment amount', type: 'danger' });
      return;
    }

    try {
      setSaving(true);
      await api.post(`/invoices/${invoiceId}/pay`, payment);
      setToast({ show: true, message: '✅ Payment recorded successfully!', type: 'success' });
      setTimeout(() => navigate('/invoices'), 1500);
    } catch (err) {
      console.error(err);
      setToast({ show: true, message: '❌ Failed to record payment.', type: 'danger' });
    } finally {
      setSaving(false);
    }
  };

  if (loadingInvoice) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-primary" role="status"></div>
        <p className="mt-3">Loading invoice...</p>
      </div>
    );
  }

  if (!invoice) {
    return (
      <div className="container mt-5 text-center text-danger">
        Invoice not found.
      </div>
    );
  }

  const pendingAmount = parseFloat(invoice.TotalAmount || 0) - parseFloat(invoice.Discount || 0) - parseFloat(invoice.PaidAmount || 0);

  return (
    <div className="container mt-4">
      <BackButton />
      <h3 className="mb-4">💳 Invoice Payment</h3>

      <div className="row">
        <div className="col-md-6 mb-4">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-primary text-white">
              Invoice Details
            </div>
            <div className="card-body">
              <p><strong>Invoice No:</strong> {invoice.InvoiceNo}</p>
              <p><strong>Customer:</strong> {invoice.CustomerName || 'N/A'}</p>
              <p><strong>Total:</strong> ₹{Number(invoice.TotalAmount).toFixed(2)}</p>
              <p><strong>Discount:</strong> ₹{Number(invoice.Discount).toFixed(2)}</p>
              <p><strong>Paid:</strong> ₹{Number(invoice.PaidAmount).toFixed(2)}</p>
              <p><strong>Pending:</strong> ₹{Math.max(pendingAmount, 0).toFixed(2)}</p>
              <p>
                <strong>Status:</strong>{' '}
                <span className={`badge ${invoice.PaymentStatus === 'Paid' ? 'bg-success' : invoice.PaymentStatus === 'Partial' ? 'bg-warning text-dark' : 'bg-danger'}`}>
                  {invoice.PaymentStatus}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-secondary text-white">
              Record Payment
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Payment Amount (₹)</label>
                  <input
                    type="number"
                    name="PaidAmount"
                    className="form-control"
                    value={payment.PaidAmount}
                    onChange={handlePaymentChange}
                    required
                    placeholder="Enter amount"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Payment Mode</label>
                  <select
                    name="PaymentMode"
                    className="form-select"
                    value={payment.PaymentMode}
                    onChange={handlePaymentChange}
                  >
                    <option value="Cash">Cash</option>
                    <option value="UPI">UPI</option>
                    <option value="Card">Card</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Remarks (Optional)</label>
                  <textarea
                    name="Remarks"
                    className="form-control"
                    value={payment.Remarks}
                    onChange={handlePaymentChange}
                    placeholder="Any remarks"
                  />
                </div>

                <button type="submit" className="btn btn-success w-100" disabled={saving}>
                  {saving ? (
                    <span>
                      <span className="spinner-border spinner-border-sm me-2"></span> Saving...
                    </span>
                  ) : (
                    '💾 Record Payment'
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {toast.show && (
        <div className={`toast show position-fixed bottom-0 end-0 m-3 text-white bg-${toast.type}`}>
          <div className="toast-body">
            {toast.message}
          </div>
        </div>
      )}
    </div>
  );
}
